export default __webpack_public_path__ + "static/media/transition-audio.ecec9883.mp3";